import React, { useState, useEffect } from "react";
import { keyframes,styled } from "styled-components";
import { formatHHMM } from "../../utils/timeUtils.js";
import SideMenu from "./SideMenu";
import MultiCircularSlider from "./MultiCircularSlider"; // 複数のスライダーを表示するコンポーネント
import { RecordingStatus } from "../enum.js";

// 円のsvgを定義
const SVGContainer = styled.svg`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10000;
  width: 100%;
  height: 100%;
  pointer-events: none; // クリックイベントを無視
`;

// 点滅のアニメーション
const fadeInOut = keyframes`
  0%, 100% {
    opacity: 0; /* 完全に透明 */
    fill: rgba(66, 207, 141, 0); /* 最初は透明な緑 */
  }
  50% {
    opacity: 1; /* 最大表示 */
    fill: rgba(66, 207, 141, 1); /* 明るい緑 */
  }
`;


const UILayer = ({ 
  currentTime,
  angle=323,
  onSliderChange,
  recordingStatus,
  setRecordingStatus,
  setShowReport,
  anothreSimulatorName,
  linkToAnothreSimulator,
  canReport,
  reverse,
  setReverse
}) => {
  const [radiusInSvg, setRadius] = useState(0); // svg座標系における円の半径
  const [isMenuOpen, setIsMenuOpen] = useState(false); // メニュー開閉状態
  const [isSliderVisible, setIsSliderVisible] = useState(false); // スライダーがみえているかどうか

 // ダウンロードアイコンのトリガーを処理
 const handleDownloadTrigger = () => {
  if ([RecordingStatus.NONE,RecordingStatus.COMPLETED].includes(recordingStatus)){ // 実行中の記録がなければ
    setRecordingStatus(RecordingStatus.START); // 記録を開始
  }
};

 //メニューがクリックされたかどうか
const handleMenuToggle = () => {
  const newMenuOpenState = !isMenuOpen;
  setIsMenuOpen(newMenuOpenState);
  if (!newMenuOpenState) {
    setIsSliderVisible(false);
  }
};

// ダウンロードがクリックされたかどうか
const handleDownloadClick = () => {
  setShowReport(true); // リポートを見える状態にする．
};


// SETTINGがクリックされた際にスライダーの表示状態を反転
const handleSettingClick = () => {
  setIsSliderVisible((prev) => !prev); // 現在の状態を基に反転
  console.log(`Slider visibility set to ${!isSliderVisible}`); // 新しい状態をログ出力
};

// reverseがクリックされた際にスライダーの表示状態を反転
const handlereverselick = () => {
  setReverse(!reverse); // reverse 状態を反転
};


// 円周パスを動的に作成
const circlePath = `
M 50,50
m ${radiusInSvg},0
a ${radiusInSvg},${radiusInSvg} 0 1,0 -${radiusInSvg * 2},0
a ${radiusInSvg},${radiusInSvg} 0 1,0 ${radiusInSvg * 2},0
`;


  //スライダーデータ
  const [sliders, setSliders] = useState([
    { id: 1, startAngle: 160, endAngle: 220, radiusPercentage: 0.9,name: "train coverage", min: "100", max: "1000 m",minValue: 100, maxValue: 1000, initialValue: 500,option:false},
    { id: 2, startAngle: 220, endAngle: 270, radiusPercentage: 0.95 ,name: "bus coverage", min: "50", max: "500 m",minValue: 50, maxValue: 500,initialValue: 300,option:false},
    { id: 3, startAngle: 230, endAngle: 300, radiusPercentage: 0.85 ,name: "speed scale", min: "1", max: "5000",minValue: 1, maxValue: 5000,initialValue: 100,option:true},
  ]);



  const viewBoxSize = 100; // SVGのviewBoxサイズを100に設定 
  const icon_size = 5; // 画像のサイズ


  // 任意の角度で画像を配置するための座標計算
  const angleInRadians_record = (angle * Math.PI) / 180; // 角度をラジアンに変換
  const angleInRadians_setting = ((angle+7) * Math.PI) / 180; // 角度をラジアンに変換
  const angleInRadians_mapbox = ((angle+230) * Math.PI) / 180; // 角度をラジアンに変換
  const angleInRadians_dl = ((angle+14) * Math.PI) / 180; // 角度をラジアンに変換
  const angleInRadians_rev = ((angle+23) * Math.PI) / 180; // 角度をラジアンに変換

  const imageX_record = viewBoxSize / 2 + radiusInSvg * Math.cos(angleInRadians_record) - icon_size+2; // X座標（3は画像サイズ補正）
  const imageY_record = viewBoxSize / 2 - radiusInSvg * Math.sin(angleInRadians_record) - icon_size+2; // Y座標（3は画像サイズ補正）

  const imageX_setting = viewBoxSize / 2 + radiusInSvg * Math.cos(angleInRadians_setting) - icon_size+2; // X座標（3は画像サイズ補正）
  const imageY_setting = viewBoxSize / 2 - radiusInSvg * Math.sin(angleInRadians_setting) - icon_size+2; // Y座標（3は画像サイズ補正）

  const imageX_dl = viewBoxSize / 2 + radiusInSvg * Math.cos(angleInRadians_dl) - icon_size+2; // X座標（3は画像サイズ補正）
  const imageY_dl = viewBoxSize / 2 - radiusInSvg * Math.sin(angleInRadians_dl) - icon_size+2; // Y座標（3は画像サイズ補正）

  const imageX_mb = viewBoxSize / 2 + radiusInSvg * Math.cos(angleInRadians_mapbox) - icon_size+5.8; // X座標（3は画像サイズ補正）
  const imageY_mb = viewBoxSize / 2 - radiusInSvg * Math.sin(angleInRadians_mapbox) - icon_size+6; // Y座標（3は画像サイズ補正）

  const imageX_rv = viewBoxSize / 2 + radiusInSvg * Math.cos(angleInRadians_rev) - icon_size+2; // X座標（3は画像サイズ補正）
  const imageY_rv = viewBoxSize / 2 - radiusInSvg * Math.sin(angleInRadians_rev) - icon_size+2; // Y座標（3は画像サイズ補正）

  
  

  // ウィンドウサイズが変更されたときに半径を再計算
  const updateRadius = () => {
    const shortEdge = Math.min(window.innerWidth, window.innerHeight); // 画面の短辺を取得
    const radiusPercentage = 0.78; // 短辺に対する割合
    const calculatedRadius = shortEdge * radiusPercentage; // ピクセル単位での半径

    // viewBox座標系にスケール変換
    const scaledRadius = (calculatedRadius / shortEdge) * 50; // 50はviewBoxの短辺スケールに対応

    // 値が変わった場合のみステートを更新
    if (scaledRadius !== radiusInSvg) {setRadius(scaledRadius);}
  };

  // 初回マウント時とリサイズ時に半径を更新
  useEffect(() => {
    updateRadius(); // 初回マウント時に計算
    window.addEventListener("resize", updateRadius); // リサイズイベントを監視

    // クリーンアップ処理
    return () => {
      window.removeEventListener("resize", updateRadius);
    };
  }, []); // 空の依存配列で一度だけ実行

  /**
   * return
   */
  return (
    <div>
      <SVGContainer viewBox="0 0 100 100" preserveAspectRatio="xMidYMid meet">
        <defs>
          <path id="circlePath" d={circlePath} />
        </defs>
        {/* テキスト */}
        <text fill="white" fontSize="3" fontFamily="'Nanum Myeongjo', serif"　style={{ pointerEvents: "none" }} // テキストの選択を無効化
        >
        <textPath href="#circlePath" startOffset="85%">
          {formatHHMM(currentTime)}
        </textPath>
        </text>
        <text fill="rgba(255,255,255,0.8)" fontSize="1.5" fontFamily="'Nanum Myeongjo', serif" style={{ pointerEvents: "auto" }}>
          <textPath href="#circlePath" startOffset="60%">
            <a href="https://www.mapbox.com/about/maps" target="_blank" rel="noopener noreferrer" style={{ fill: "rgba(255,255,255,0.8)", textDecoration: "none"}}>
              © Mapbox &nbsp;&nbsp;
            </a>
            <a href="https://www.openstreetmap.org/about/" target="_blank" rel="noopener noreferrer" style={{ fill: "rgba(255,255,255,0.8)", textDecoration: "none"}}>
              © OpenStreetMap
            </a>
          </textPath>
        </text>



      {/* レコードアイコン */}
      {canReport && (
        <image
          href={`${process.env.PUBLIC_URL}/svg/record.svg`}
          width={icon_size} // 画像の幅
          height={icon_size }// 画像の高さ
          x={imageX_record} // 計算されたX座標
          y={imageY_record} // 計算されたY座標
          style={{ 
            fill: "rgb(66, 207, 141)",
            zIndex: 10001,
            position: "relative" ,
            pointerEvents: "auto",
            animation: recordingStatus === RecordingStatus.IN_PROGRESS ? "fadeInOut 1s infinite" : "none", // 点滅時はアニメーション適用、固定時はアニメーションなし
          }} // 色を白に変更し、z-indexを最上に設定
          
          //レポート処理に回す    
          onClick={handleDownloadTrigger} // クリック時にダウンロードアイコンを表示
      
        />
      )}
      

      {/* 設定アイコン */}
      <image
          href={`${process.env.PUBLIC_URL}/svg/more.svg`}
          width={icon_size} // 画像の幅
          height={icon_size} // 画像の高さ
          x={imageX_setting} // 計算されたX座標
          y={imageY_setting} // 計算されたY座標
          transform={`rotate(122, ${imageX_setting + icon_size / 2}, ${imageY_setting + icon_size / 2})`} // 画像を回転
          style={{ fill: "rgb(66, 207, 141)", zIndex: 10001, position: "relative", pointerEvents: "auto" }} // 色を白に変更し、z-indexを最上に設定
          onClick={handleMenuToggle} // クリック時にメニュー表示を切り替え
      />

       {/* ダウンロードアイコン */}
       {(recordingStatus === RecordingStatus.COMPLETED) && (
          <image
            href={`${process.env.PUBLIC_URL}/svg/download.svg`}
            width={icon_size}
            height={icon_size}
            x={imageX_rv}
            y={imageY_rv}
            transform={`rotate(0, ${imageX_rv + icon_size / 2}, ${imageY_rv + icon_size / 2})`}
            onClick={handleDownloadClick}
            style={{ pointerEvents: "auto" }}
          />
        )}

            {/* reverseアイコン */}
   
          <image
            href={`${process.env.PUBLIC_URL}/svg/reverse.svg`}
            width={icon_size}
            height={icon_size}
            x={imageX_dl}
            y={imageY_dl}
            transform={`rotate(0, ${imageX_dl + icon_size / 2}, ${imageY_dl + icon_size / 2})`}
            onClick={handlereverselick}
            style={{ pointerEvents: "auto" }}
          />
     

        {/* mapbox ロゴ */}
        <a href="https://www.mapbox.com/" target="_blank" rel="noopener noreferrer">
          <image
            className="flashing-icon"
            href={`${process.env.PUBLIC_URL}/svg/mapbox-logo-white.svg`}
            width={icon_size + 5} // 画像の幅
            height={icon_size + 5} // 画像の高さ
            x={imageX_mb} // 計算されたX座標
            y={imageY_mb} // 計算されたY座標
            transform={`rotate(63, ${imageX_mb + icon_size / 2}, ${imageY_mb + icon_size / 2})`} // 画像を回転
            style={{ fill: "rgb(66, 207, 141)", zIndex: 10001, position: "relative", cursor: "pointer", pointerEvents: "auto" }} // 色を白に変更し、z-indexを最上に設定
           
            />
        </a>


        {/* ダウンロードボタン出現アニメーション */}
        <style>
        {`
          @keyframes fadeInOut {
            0%, 100% {
              opacity: 0;
              fill: rgba(66, 207, 141, 0);
            }
            50% {
              opacity: 1;
              fill: rgba(66, 207, 141, 1);
            }
          }
        `}
      </style>
      </SVGContainer>
      
       {/* サイドメニュー */}
      <SideMenu isOpen={isMenuOpen} onSettingClick={handleSettingClick} simulatorName={anothreSimulatorName} linkToSimulator={linkToAnothreSimulator}/> 

      {/* 設定画面 */}
      {isSliderVisible && (

          <MultiCircularSlider
            sliders={sliders}
            onValueChange={onSliderChange} // 値の変更を受け取る
          />

      )}


    </div>
  );
};


export default UILayer;
